var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86438 1.17136C5.37242 0.276213 6.62758 0.276213 7.13562 1.17136L11.82 9.48792C12.328 10.3831 11.7004 11.5 10.6918 11.5H1.30815C0.299558 11.5 -0.328018 10.3831 0.180014 9.48792L4.86438 1.17136ZM6 3.08407C6.30631 3.08407 6.56033 3.3442 6.56033 3.65789V6.33568C6.56033 6.64937 6.30631 6.90949 6 6.90949C5.69369 6.90949 5.43967 6.64937 5.43967 6.33568V3.65789C5.43967 3.3442 5.69369 3.08407 6 3.08407ZM6 9.96983C6.41091 9.96983 6.74711 9.62554 6.74711 9.20475C6.74711 8.78395 6.41091 8.43966 6 8.43966C5.58909 8.43966 5.25289 8.78395 5.25289 9.20475C5.25289 9.62554 5.58909 9.96983 6 9.96983Z",
    fill: "#F77706"
  })));
};
export default __webpack_public_path__ + "assets/6bb55b6e71b4ee988bbc1b52001cecda.svg";
export { SvgWarning as ReactComponent };


// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/icons/warning.svg